import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, Stack, Typography } from '@mui/material';

import { date } from '@/utilities/dateUtils';
import { ctxRefuel } from '@/contexts/RefuelsCtx';

import './RefuelStyle.css';

export function RefuelsSummary() {
  const ctx = useContext(ctxRefuel);
  const { t } = useTranslation();
  const [summRefuel, setSummRefuel] = useState<number | undefined>(undefined);

  const [summarySelectedDates, setSummarySelectedDates] = useState(ctx?.selectedDates);
  const [prevSelectedTarget, setPrevSelectedTarget] = useState(ctx?.selectedTarget);

  useEffect(() => {
    if (!ctx) return;
    if (ctx.refuels) {
      setSummRefuel(ctx.refuels.reduce((acc, refuel) => acc + refuel.fillAmount, 0));

      if (ctx.selectedDates) {
        setSummarySelectedDates(ctx.selectedDates);
      }
    }
  }, [ctx]);

  useEffect(() => {
    if (!ctx) return;
    if (ctx.selectedTarget !== prevSelectedTarget) {
      setSummarySelectedDates(undefined);
      setPrevSelectedTarget(ctx.selectedTarget);
    }
  }, [ctx, prevSelectedTarget]);

  if (!ctx) return null;

  return (
    <div>
      <Card className="refuels-summary-card">
        <CardContent className="refuels-summary-card-content" data-qa-element-id="refuel_summary_panel">
          <Typography variant="h5" component="div">
            <span data-qa-element-id="refuel_summary_panel_title">
              {t('refuels.aggregatedDataSort') + ' ('}
              {ctx.refuels?.length ? ctx.refuels.length : 0} {`${t('refuels.summary.refueling').toLowerCase()})`}
            </span>
          </Typography>
          <Typography variant="body2" component="div">
            <Stack direction="row" gap={2} className="refuels-summary-card-body">
              <div>
                {summarySelectedDates && (
                  <Typography variant="body2" data-qa-element-id="date_intarval_label">
                    {t('refuels.summary.dateRange')}:
                  </Typography>
                )}
                {ctx.refuels && (
                  <Typography variant="body2" data-qa-element-id="fuel_fillings_label">
                    {t('refuels.title')}:
                  </Typography>
                )}
              </div>
              <div>
                {summarySelectedDates && (
                  <Typography variant="subtitle2" data-qa-element-id="refuel_summary_date_interval">
                    {date(summarySelectedDates.from, t)} - {date(summarySelectedDates.to, t)}
                  </Typography>
                )}
                {ctx.refuels && (
                  <Typography variant="subtitle2" color="secondary" data-qa-element-id="refuel_summary_fill_amount">
                    {summRefuel?.toFixed(1)} L
                  </Typography>
                )}
              </div>
            </Stack>
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
}
